import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { Collapse, CollapseItem, Dialog, Toast, Notify } from "vant";
import 'vant/lib/index.css';
import App from './App.vue'
import router from './router/router'
createApp(App)
    .use(ElementPlus)
    .use(router)
    .use(Collapse)
    .use(CollapseItem)
    .use(Dialog)
    .use(Toast)
    .use(Notify)
    .mount("#app");

router.beforeEach((to, from, next) => {
    // 路由发生变化修改页面title
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
createApp(App).use(store).use(axios).mount('#app')
